import { Button, Dialog, Text } from '@noorden-insurtech/alba-design-system';
import { FileText } from 'lucide-react';
import type { ReactNode } from 'react';

interface GeneratePdfDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  /** Título do dialog — default preserva o texto usado por Residencial/Empresarial. */
  title?: string;
  /** Texto do corpo — default preserva o texto usado por Residencial/Empresarial. */
  description?: ReactNode;
}

export function GeneratePdfDialog({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title = 'Gerar PDF',
  description = (
    <>
      <Text className='text-sm text-alba-gray-600'>
        O PDF da cotação será gerado para download.
      </Text>
      <Text className='text-sm text-alba-gray-600'>Deseja continuar?</Text>
    </>
  ),
}: GeneratePdfDialogProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='w-[480px] max-w-[480px] rounded-[24px] p-6 shadow-xl'>
          <div className='flex flex-col items-start gap-8'>
            <Dialog.Header className='w-full p-0'>
              <Dialog.Title className='w-full'>
                <div className='flex w-full items-center justify-between gap-3'>
                  <div className='flex items-center gap-2'>
                    <FileText className='h-6 w-6 text-alba-black-500' />
                    <Text className='text-lg font-bold text-alba-black-500'>
                      {title}
                    </Text>
                  </div>
                  <Dialog.CloseButton onClick={onClose} />
                </div>
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body className='w-full px-6 py-0'>
              <div className='flex flex-col items-start gap-2'>
                {description}
              </div>
            </Dialog.Body>

            <Dialog.Footer className='w-full p-0 px-6'>
              <div className='flex w-full items-center justify-end gap-6'>
                <Dialog.CloseTrigger asChild>
                  <Button variant='ghost' size='md'>
                    Cancelar
                  </Button>
                </Dialog.CloseTrigger>
                <Button
                  variant='primary'
                  size='md'
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={onConfirm}
                >
                  Gerar e Baixar
                </Button>
              </div>
            </Dialog.Footer>
          </div>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
